<template>
  <div class="container-fluid">
    <!-- Card body -->
    <div v-if="task" class="d-flex flex-column flex-md-row align-items-md-center py-4">
      <div class="avatar-group avatar-group--cc-sm d-flex align-items-center">
        <a
          v-if="getImage(task.assigned_by).hasImage"
          href="#"
          class="avatar avatar-xl rounded-circle"
        >
          <img
            alt="Image placeholder"
            :src="getImage(task.assigned_by).avatar"
            data-toggle="tooltip"
            title="This comment is viewable by: Suman Khatiwada"
          />
        </a>

        <a
          v-if="!getImage(task.assigned_by).hasImage"
          href="#"
          :class="getImage(task.assigned_by).bg"
          class="avatar avatar-xl avatar-name text-md text-white rounded-circle"
          data-toggle="tooltip"
          title="This comment is viewable by: Suman Khatiwada"
          data-target="offcanvascced_int"
          data-offcanvasfrom="offcanvas"
        >{{getImage(task.assigned_by).avatar}}</a>

        <div class="pl-3">
          <h1 class="h2 text-black lh-110 mb-2">{{ task.project.name }}</h1>
          <span class="text-primary">{{ task.name }}</span>
        </div>
      </div>
      <div class="mt-sm-0 mt-4 ml-md-auto d-flex flex-column flex-sm-row align-items-sm-center">
        <div class="progress-label mr-4">
          <span
            @click="_onTimesheetEntryClicked"
            class="text-white text-capitalize p-0 mr-1 btn btn-link timesheet-icon"
            data-toggle="tooltip"
            data-placement="top"
            title="Timesheet Icon"
            data-target="offcanvasTimer"
            data-offcanvasfrom="offcanvas"
          >
            <svg
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 89.7 89.7"
              class="icon-shape__timer-info"
            >
              <path
                class="st0"
                d="M29.1 52.7v3.1c-1.9-.4-2.5-.8-2.5-1.6v-.1c0-.8.7-1.4 2.5-1.4zM34.9 64.9c0 .8-.7 1.3-2.4 1.4v-3c1.9.3 2.4.8 2.4 1.6z"
              />
              <path
                class="st0"
                d="M30.2 29.3C13.5 29.3 0 42.8 0 59.5s13.5 30.2 30.2 30.2 30.2-13.5 30.2-30.2-13.5-30.2-30.2-30.2zm12.1 34.9c0 4.9-3.8 7.7-9.6 8.2V76h-3.8v-3.6h-.1c-4.1-.3-8.1-1.7-11.2-3.8l3.8-5.6c2.7 1.8 5.3 2.7 7.7 3.1V63c-6.5-1.3-10-3.3-10-8.1v-.1c0-4.6 3.3-7.9 9.9-8.3v-2.1h3.8v2.2c3.4.3 6.2 1.4 8.7 3L38 55.2c-1.6-1.1-3.5-1.9-5.4-2.3v3c6.2 1.2 9.7 3.1 9.7 8.3zM54.8 32.3v-.4l1.1-16v-.2c.2-1.4 1.3-2.3 2.6-2.3 1.4 0 2.5 1.1 2.6 2.4l1 14.6c0 .4.2.9.5 1.2l6.5 7.7.1.1c.8 1.1.7 2.5-.2 3.5-1 1-2.5 1.1-3.6.1l-9-7.5c-.2-.1-.3-.3-.5-.4-.7-.7-1.1-1.7-1.1-2.8 0 .1 0 .1 0 0z"
              />
              <path
                class="st0"
                d="M59.5 0c-15.9 0-29 12.4-30.1 28h.7c2.6 0 5.1.3 7.5.9.7-11.5 10.2-20.6 21.9-20.6 12.1 0 21.9 9.8 21.9 21.9 0 11.7-9.1 21.2-20.6 21.9.6 2.4.9 4.9.9 7.5v.7c15.7-1.1 28-14.1 28-30.1C89.7 13.5 76.2 0 59.5 0z"
              />
            </svg>
          </span>
          <div class="gantt_side_content gantt_left" @click="_onTimesheetBudgetClicked">
            <div class="btn-group btn-group--totalhours" role="group" aria-label="Basic example">
              <button class="btn btn-info px-0">
                <span
                  class="bg-dar text-white text-capitalize u-p-cursor px-2"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="5 out of 10 hours quoted on this Task"
                  data-target="offcanvasTimer"
                  data-offcanvasfrom="offcanvas"
                >5/10</span>
              </button>
              <button class="btn btn-default px-1">
                <span
                  data-toggle="tooltip"
                  class="px-0"
                  data-placement="top"
                  title="Project is 15 hours over quote"
                  data-target="offcanvasTimer"
                  data-offcanvasfrom="offcanvas"
                >120/105</span>
                <span
                  class="badge-secondary ml-1"
                  data-toggle="tooltip"
                  data-placement="top"
                  title="17 hours ($170) per hour = $17,000"
                  data-target="offcanvasTimer"
                  data-offcanvasfrom="offcanvas"
                >$ 1.7k</span>
              </button>
            </div>
          </div>
          
          <span class="button__fixer">
            <flat-picker
              :config="{wrap: true, allowInput: false}"
              class="form-control-value bg-danger text-white text-capitalize px-2 w-px-100 u-p-context-menu text-center date"
              v-model="selectedDate"
            ></flat-picker>
          </span>
        </div>
        <button
          class="btn btn-danger my-md-0 my-4"
          type="button"
          data-toggle="tooltip"
          data-placement="top"
          title
          data-original-title="This will close the Task and archive it for this project"
        >Complete</button>
      </div>
    </div>
    <!-- Commnet post start-->
    <div class="row">
      <div class="col-xl-12 comment-box">
        <!-- Commnet post -->
        <div class="card">
          <!-- Card header -->
          <div class="card-header">
            <div
              class="d-flex flex-column flex-md-row comment-header w-100 align-items-start align-items-md-center"
            >
              <div
                class="comment-header__left d-flex flex-column flex-sm-row align-items-sm-center"
              >
                <div class="d-flex align-items-center mr-4 mb-3 mb-sm-0">
                  <div class="comment-header__from-to">
                    <div class="d-flex w-100 align-items-center">
                      <div class="d-inline-flex mr-1">
                        <a
                          v-if="assignedByUser"
                          href="javascript:void(0)"
                          @click="_onAssignedByClicked"
                          data-target="offcanvasFrom"
                          data-offcanvasfrom="offcanvas"
                          class="avatar-group"
                        >
                          <img
                            v-if="assignedByUser.image" 
                            :src="assignedByUser.image"
                            alt="From"
                            class="avatar avatar-xs avatar--34 rounded-circle"
                            data-toggle="tooltip"
                            data-placement="top"
                            :title="'Task From: '+assignedByUser.first_name+' '+assignedByUser.last_name"
                          />

                            
                            <span class="avatar avatar-xs avatar--34 rounded-circle" v-else>{{(assignedByUser.first_name || 'NA').substring(0,2).toUpperCase()}}</span>
                        </a>
                      </div>
                      <div class="d-inline-flex mr-1">
                        <i class="fas fa-arrow-right text-xs"></i>
                      </div>
                      <div class="d-inline-flex">
                        <a
                          v-if="assignedToUser"
                          href="javascript:void(0)"
                          data-target="offcanvasTo"
                          @click="_onAssignedToClicked"
                          data-offcanvasfrom="offcanvas"
                          class="avatar-group"
                        >
                          <img
                            v-if="assignedToUser.image" 
                            :src="assignedToUser.image"
                            alt="From"
                            class="avatar avatar-xs avatar--34 rounded-circle"
                            data-toggle="tooltip"
                            data-placement="top"
                            :title="'Task To: '+assignedToUser.first_name+' '+assignedToUser.last_name"
                          />

                           <span class="avatar avatar-xs avatar--34 rounded-circle" v-else>{{(assignedToUser.first_name || 'NA').substring(0,2).toUpperCase()}}</span>
                         
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="comment-header__cc pl-4">
                    <div
                      class="avatar-group avatar-group--cc-sm d-flex align-items-center appendCced appendCced-int"
                    >
                      <a
                        href="javascript:void(0)"
                        class="cced-1 avatar avatar-xs avatar--38 rounded-circle"
                        data-toggle="tooltip"
                        data-original-title="This comment is viewable by: Ryan Tompson"
                        data-target="offcanvascced_int"
                        data-offcanvasfrom="offcanvas"
                        @click="_onCCClicked"
                      >
                        <img alt="Image placeholder" src="../../assets/img/theme/team-4.jpg" />
                      </a>
                      <a
                        href="javascript:void(0)"
                        class="cced-2 avatar avatar-xs avatar--38 rounded-circle"
                        data-toggle="tooltip"
                        data-original-title="This comment is viewable by: Ryan Tompson"
                        data-target="offcanvascced_int"
                        data-offcanvasfrom="offcanvas"
                        @click="_onCCClicked"
                      >
                        <img alt="Image placeholder" src="../../assets/img/theme/team-2.jpg" />
                      </a>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center">
                  <label class="comment-header__switch custom-toggle">
                    <input
                      type="checkbox"
                      id="grayscale"
                      value="grayscale"
                      name="grayscale_switch"
                      class="custom-control-input switch-btn"
                    />
                    <!-- <input type="checkbox"> -->
                    <span
                      class="custom-toggle-slider rounded-circle"
                      id="showRadio"
                      data-label-off="OFF"
                      data-label-on="ON"
                    ></span>
                  </label>
                  <div class="comment-header__cc__ext pl-2 ml-1">
                    <div
                      class="avatar-group avatar-group--cc-sm d-flex align-items-center appendCced appendCced-ext"
                    >
                      <a
                        href="javascript:void(0)"
                        @click="_onCSUClicked"
                        class="cced-1 avatar avatar-xs avatar--38 rounded-circle"
                        data-toggle="tooltip"
                        data-original-title="This comment is viewable by: Ryan Tompson"
                        data-target="offcanvascced_ext"
                        data-offcanvasfrom="offcanvas"
                      >
                        <img
                          alt="Image placeholder"
                          src="../../assets/img/theme/team-4.jpg"
                          class="grayscale"
                        />
                      </a>
                      <a
                        href="javascript:void()"
                        @click="_onCSUClicked"
                        class="cced-2 avatar avatar-xs avatar--38 rounded-circle"
                        data-toggle="tooltip"
                        data-original-title="This comment is viewable by: Ryan Tompson"
                        data-target="offcanvascced_ext"
                        data-offcanvasfrom="offcanvas"
                      >
                        <img
                          alt="Image placeholder"
                          src="../../assets/img/theme/team-2.jpg"
                          class="grayscale"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Card body -->
          <div class="card-body">
            <div class="d-flex flex-column flex-sm-row align-items-sm-center">
              <div class="w-100">
                <div class="row align-items-center">
                  <div class="col-auto pr-0">
                    <span class="avatar-group">
                      <a href="javascript:void(0)" class="d-inline-flex" @click="_onUploadClicked">
                        <img
                          src="../../assets/img/theme/icon-camera.png"
                          class="avatar-md"
                          alt="Upload File"
                        />
                      </a>
                    </span>
                  </div>
                  <div class="col">
                    <textarea
                      :rows="numLines"
                      v-model="comment"
                      class="form-control borderRadius-25 textarea__tweak"
                      @keydown.enter.exact="_onSubmitClicked($event)"
                    />
                  </div>
                </div>
              </div>
              <button
                class="btn btn-success ml-sm-3 mt-sm-0 mt-3"
                @click="_onSubmitClicked"
                type="button"
              >Submit</button>
            </div>
            <div class="card-body">
              <vue-clip
                :options="dropzoneOptions"
                :on-removed-file="_onFileRemoved"
                :on-complete="_onComplete"
                :on-added-file="_onFileAdded"
              >
                <template slot="clip-uploader-action">
                  <div>
                    <div class="dz-message">
                      <h5>Click or Drag and Drop files here upload</h5>
                    </div>
                  </div>
                </template>

                <template slot="clip-uploader-body">
                  <div class="tf__attachment-box">
                    <div v-for="(file, ind) in attachments" :key="ind" class="tf__content-box">
                      <a href="#" class="tf__c-b--close">
                        <i class="fas fa-times"></i>
                      </a>
                      <div v-if="file.content_type.includes('image')" class="image">
                        <img v-bind:src="file.file_url" />
                        <div class="tf__c-b--filename">{{ file.user_file_name }}</div>
                      </div>
                      <div v-else class="file">
                        <div class="tf__c-b--file">
                          <img src="@/assets/img/icons/svgs/solid/arrowLeft.svg" />
                        </div>
                        <div class="tf__c-b--filename">{{ file.user_file_name }}</div>
                      </div>
                    </div>
                    <div class="tf__content-box" v-if="uploading">
                      <div class="loading">
                        <i class="fas fa-spinner fa-pulse"></i>
                      </div>
                    </div>
                  </div>
                </template>
              </vue-clip>
            </div>
          </div>
        </div>

        <!-- Messages -->
        <div class="card">
          <!-- Card body -->
          <div class="card-body card-body--3 p-0" v-if="task">
            <!-- List group -->
            <div
              class="list-group list-group-flush flex-column-reverse"
              v-for="(cmt, ind) in task.comments"
              :key="ind"
            >
              <div
                class="list-group-item list-group-item-action flex-column align-items-start py-4 px-4"
              >
                <div
                  class="d-flex flex-column flex-md-row comment-header w-100 align-items-md-center"
                >
                  <div class="comment-header__left">
                    <div class="d-flex">
                      <div class="comment-header__from-to align-items-center">
                        <div class="d-flex w-100 align-items-center">
                          <div class="d-inline-flex mr-1">
                            <a
                              href="javascript:void(0)"
                              data-target="offcanvasFrom"
                              data-offcanvasfrom="offcanvas"
                              class="avatar-group"
                            >
                              <img
                                src="../../assets/img/theme/team-1.jpg"
                                alt="From"
                                class="avatar avatar-xs avatar--34 rounded-circle"
                                data-toggle="tooltip"
                                data-placement="top"
                                title
                                data-original-title="Task From: Gabriel Garcia"
                              />
                            </a>
                          </div>
                          <div class="d-inline-flex mr-1">
                            <i class="fas fa-arrow-right text-xs"></i>
                          </div>
                          <div class="d-inline-flex">
                            <a
                              href="javascript:void(0)"
                              data-target="offcanvasTo"
                              data-offcanvasfrom="offcanvas"
                              class="avatar-group"
                            >
                              <img
                                src="../../assets/img/theme/team-1.jpg"
                                alt="To"
                                class="avatar avatar-xs avatar--34 rounded-circle"
                                data-toggle="tooltip"
                                data-placement="top"
                                title
                                data-original-title="Task To: Suman Khatiwada"
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                      <div class="comment-header__cc align-self-center pl-4">
                        <div class="avatar-group avatar-group--cc-sm d-flex align-items-center">
                          <a
                            href="#"
                            class="avatar avatar-xs avatar--38 rounded-circle"
                            data-toggle="tooltip"
                            data-original-title="This comment is viewable by: Ryan Tompson"
                            data-target="offcanvascced"
                            data-offcanvasfrom="offcanvas"
                          >
                            <img alt="Image placeholder" src="../../assets/img/theme/team-1.jpg" />
                          </a>
                          <a
                            href="#"
                            class="avatar avatar-xs avatar--38 rounded-circle"
                            data-toggle="tooltip"
                            data-original-title="This comment is viewable by: Romina Hadid"
                            data-target="offcanvascced"
                            data-offcanvasfrom="offcanvas"
                          >
                            <img alt="Image placeholder" src="../../assets/img/theme/team-2.jpg" />
                          </a>
                          <a
                            href="#"
                            class="avatar avatar-xs avatar--38 rounded-circle"
                            data-toggle="tooltip"
                            data-original-title="This comment is viewable by: Alexander Smith"
                            data-target="offcanvascced"
                            data-offcanvasfrom="offcanvas"
                          >
                            <img alt="Image placeholder" src="../../assets/img/theme/team-3.jpg" />
                          </a>
                          <a
                            href="#"
                            class="avatar avatar-xs avatar--38 avatar-name bg-success text-md text-white rounded-circle"
                            data-toggle="tooltip"
                            data-original-title="This comment is viewable by: Suman Khatiwada"
                            data-target="offcanvascced"
                            data-offcanvasfrom="offcanvas"
                          >SK</a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="comment-header__right mt-2 mt-md-0 ml-md-auto">
                    <div class="progress-label row">
                      <small class="col-auto mr--2">2 hrs ago</small>
                      <div class="col-auto d-flex">
                        <span
                          class="bg-danger text-white text-capitalize px-2 mr-1"
                          data-toggle="tooltip"
                          data-placement="top"
                          title
                          data-original-title="12 out of 10 hours quoted on this Task"
                        >12/10</span>
                        <span
                          class="bg-dark text-white text-capitalize px-2 mr-1"
                          data-toggle="tooltip"
                          data-placement="top"
                          title
                          data-original-title="Comment Number 4"
                        >4</span>
                        <span
                          class="bg-danger text-white text-capitalize px-2"
                          data-toggle="tooltip"
                          data-placement="top"
                          title
                          data-original-title="Due Date"
                        >20th January 2019</span>
                      </div>
                    </div>
                    <!-- <span  class="badge badge-pill badge-success text-capitalize" data-toggle="tooltip" data-placement="top" title="Due Date" >30th January 2019</span> -->
                  </div>
                </div>
                <!-- comment Content -->
                <div class="comment-description mt-4" v-html="cmt.comment"></div>
                <br />
                <div class="tf__attachment-box">
                  <div v-for="(file, ind) in cmt.attachments" :key="ind" class="tf__content-box">
                    <!-- <a href="#" class="tf__c-b--close">
                        <i class="fas fa-times"></i>
                    </a>-->
                    <div v-if="file.content_type.includes('image')" class="image">
                      <img v-bind:src="file.file_url" />
                      <div class="tf__c-b--filename">{{ file.user_file_name }}</div>
                    </div>
                    <div v-else class="file">
                      <div class="tf__c-b--file">
                        <img src="@/assets/img/icons/svgs/solid/arrowLeft.svg" />
                      </div>
                      <div class="tf__c-b--filename">{{ file.user_file_name }}</div>
                    </div>
                  </div>
                  <!-- <div class="tf__content-box" v-if="uploading">
                      <div class="loading">
                        <i class="fas fa-spinner fa-pulse"></i>
                      </div>
                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Footer -->
    <footer class="footer pt-0">
      <div class="row align-items-center justify-content-lg-between">
        <div class="col">
          <div class="copyright text-center text-lg-left text-muted">
            &copy; 2019
            <a
              href="https://www.creative-tim.com"
              class="font-weight-bold ml-1"
              target="_blank"
            >TaskForm</a>
          </div>
        </div>
      </div>
    </footer>

    <SidebarRight
      @overlayClicked="outside"
      v-click-outside="outside"
      :class="['navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--400', {'open': showSideBar}]"
    >
      <component :sidebarMode="sidebarMode" :is="currentView" :sideBarUsers="sideBarUsers" :sideBarUser="sideBarUser" @userSelected="_onUserSelected"  />
    </SidebarRight>
  </div>
</template>
<script>
import { mapMutations, mapState, mapActions } from "vuex";
import SidebarRight from "@/app/layout/SidebarRight";
import { FadeTransition } from "vue2-transitions";

//sidebar components
import Another from "@/app/components/Another.vue";
import MultiUserPicker from "@/app/components/taskdetails/MultiUserPicker.vue";
import SingleUserPicker from "@/app/components/taskdetails/SingleUserPicker.vue";
import TimesheetBudget from "@/app/components/taskdetails/TimesheetBudget.vue";
import TimesheetEntry from "@/app/components/taskdetails/TimesheetEntry.vue";

import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";
export default {
  name: "TaskDetails",
  components: {
    Another,
    SidebarRight,
    MultiUserPicker,
    SingleUserPicker,
    TimesheetBudget,
    TimesheetEntry,
    flatPicker
  },
  data() {
    return {
      sideBarUser: null,
      assignedByUser: null,
      sideBarUsers: [],
      assignedToUser:null,
      ccUsers: [],
      csuUsers:[],
      uploading: false,
      showSideBar: false,
      currentView: null,
      sidebarMode: null,
      selectedDate: "2020-12-10",
      comment: null,
      attachments: [
        // {
        //   user_file_name: "iPhone Developer: Sagar Devkota (S3Z6724LKV).cer",
        //   content_type: "application/octet-stream",
        //   imageable_type: "App\\Models\\TasksComment",
        //   updated_at: "2020-02-28 18:03:30",
        //   created_at: "2020-02-28 18:03:30",
        //   id: 25,
        //   file_url:
        //     "http://api.taskfrom.com/storage/tasks/comments/applications/file-1582873410.cer"
        // },
        // {
        //   user_file_name: "taskhome.png",
        //   content_type: "image/png",
        //   imageable_type: "App\\Models\\TasksComment",
        //   updated_at: "2020-02-28 18:01:44",
        //   created_at: "2020-02-28 18:01:44",
        //   id: 24,
        //   file_url:
        //     "http://api.taskfrom.com/storage/tasks/comments/images/comment-1582873304.png"
        // }
      ],
      dropzoneOptions: {
        url:
          process.env.VUE_APP_BASE_URL +
          "/v2/attachments",
        thumbnailWidth: 150,
        maxFilesize: 2,
        thumbnailWidth: 200,
        paramName: "attachment",
        headers: { Authorization: "Bearer " + this.$auth.getToken() }
      }
    };
  },
  computed: {
    ...mapState("task", ["task"]),
    numLines() {
      return (this.comment && this.comment.split(/\r\n|\r|\n/).length) || 1;
    },
    assignedByImage() {
      let avatar = "";
      let bg_colors = [
        "bg-success",
        "bg-info",
        "bg-default",
        "bg-darker",
        "bg-danger"
      ];
      let bg = "bg-success";
      let hasImage = false;
      if (this.task.assigned_by) {
        if (this.task.assigned_by.image != null) {
          avatar = this.task.assigned_by.image;
          hasImage = true;
        } else {
          hasImage = false;
          let ch = this.task.assigned_by.first_name
            .substring(0, 1)
            .toUpperCase();
          bg = bg_colors[ch.charCodeAt(0) % 5];
          avatar =
            this.task.assigned_by.first_name.substring(0, 1).toUpperCase() +
            (
              (this.task.assigned_by.last_name &&
                this.task.assigned_by.last_name.substring(0, 1)) ||
              ""
            ).toUpperCase();
        }
      } else {
        avatar = "NU";
        //task_return += '<span class="mr-1"><i class="fas fa-arrow-'+task.which_task+'"></i></span>';
      }

      // <span data-toggle="tooltip" data-trigger="hover" title="No User" class="d-flex mr-1"><a href="#" class="avatar avatar-name avatar-sm  '+bg+' text-xl text-white rounded-circle" data-target="offcanvasFrom" data-offcanvasfrom="offcanvas">NU</a></span>

      return {
        hasImage: hasImage,
        avatar: avatar,
        bg: bg
      };
    }
  },
  watch: {
    ganttRender(val) {
      if (val) {
        this.fetchAllTasks();
      }
    }
  },
  mounted() {
    let params = this.$route.params;
    let token = this.$auth.getToken();

    this.$nextTick(() => {
      try {
        //$('[data-toggle="tooltip"]').tooltipster('destroy');
        $('[data-toggle="tooltip"]').tooltipster({
          theme: "tooltipster-borderless"
        });
      } catch (e) {}

      this.fetchTaskDetails(params["taskId"]).then(r => {
        
        this.assignedByUser = r.assigned_by
        this.assignedToUser = r.task_assigned_to
      });
    });
  },
  methods: {
    ...mapActions("task", ["fetchTaskDetails", "saveTaskComment"]),
    ...mapMutations(["setLoading"]),
    _onFileAdded() {
      this.uploading = true;
    },
    _onFileRemoved(file) {},
    _onComplete(file, status, xhr) {
      this.uploading = false;

      if (file.errorMessage) {
        this.$snack.success(file.errorMessage);
      } else {
        let body = JSON.parse(xhr.response);
        this.attachments = [...this.attachments, body.data];
        console.log(xhr.response, "came after upload");
      }
    },
    _onUploadClicked() {
      document.getElementsByClassName("dz-clickable")[0].click();
    },
    _onAssignedToClicked() {
      this.showSideBar = true;
      this.currentView = "SingleUserPicker";
      this.sidebarMode = "ASSIGN_TO";
      this.sideBarUser = this.assignedToUser
    },

    _onAssignedByClicked() {
      this.showSideBar = true;
      this.currentView = "SingleUserPicker";
      this.sidebarMode = "ASSIGN_BY";
      this.sideBarUser = this.assignedByUser
    },

    _onTimesheetEntryClicked() {
      this.showSideBar = true;
      this.currentView = "TimesheetEntry";
      this.sidebarMode = "TIMESHEET_ENTRY";
    },

    _onTimesheetBudgetClicked() {
      this.showSideBar = true;
      this.currentView = "TimesheetBudget";
      this.sidebarMode = "TIMESHEET_BUDGET";
    },

    _onCCClicked() {
      this.showSideBar = true;
      this.currentView = "MultiUserPicker";
      this.sidebarMode = "CC";
      this.sideBarUsers = this.ccUsers
    },

    _onCSUClicked() {
      this.showSideBar = true;
      this.currentView = "MultiUserPicker";
      this.sidebarMode = "CSU";
      this.sideBarUsers = this.csuUsers
    },

    _onUserSelected(data) {
      if(this.sidebarMode == "CC") {
        this.ccUsers = data
      } else if(this.sidebarMode == "CSU") {
        this.csuUsers = data
      } else if(this.sidebarMode == "ASSIGN_TO") {
        this.assignedToUser = data
      } else if(this.sidebarMode == "ASSIGN_BY") {
        this.assignedByUser = data
      }
    },

    outside() {
      this.showSideBar = false;
    },

    _onSubmitClicked(e) {
      e.preventDefault();
      if (this.comment && this.comment.replace(/\n/g, "").length > 0) {
        let body = {
          comment: this.linkify(this.comment.replace(/\n/g, "<br />")),
          taskId: this.task.id,
          attachments: this.attachments
        };

        if (this.uploading == false) {
          this.saveTaskComment(body)
            .then(r => {
              this.fetchTaskDetails(this.task.id);
              this.comment = null;
              this.attachments = [];
            })
            .catch(err => {
              this.$snack.success("Could not save comment due to an error!");
            });
        }
      }
    },

    linkify(text) {
      var urlRegex = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
      return text.replace(urlRegex, function(url) {
        return '<a href="' + url + '">' + url + "</a>";
      });
    },

    getImage(user) {
      let avatar = "";
      let bg_colors = [
        "bg-success",
        "bg-info",
        "bg-default",
        "bg-darker",
        "bg-danger"
      ];
      let bg = "bg-success";
      let hasImage = false;
      if (user) {
        if (user.image != null) {
          avatar = user.image;
          hasImage = true;
        } else {
          hasImage = false;
          let ch = user.first_name.substring(0, 1).toUpperCase();
          bg = bg_colors[ch.charCodeAt(0) % 5];
          avatar =
            user.first_name.substring(0, 1).toUpperCase() +
            (
              (user.last_name && user.last_name.substring(0, 1)) ||
              ""
            ).toUpperCase();
        }
      } else {
        avatar = "NU";
        //task_return += '<span class="mr-1"><i class="fas fa-arrow-'+task.which_task+'"></i></span>';
      }

      // <span data-toggle="tooltip" data-trigger="hover" title="No User" class="d-flex mr-1"><a href="#" class="avatar avatar-name avatar-sm  '+bg+' text-xl text-white rounded-circle" data-target="offcanvasFrom" data-offcanvasfrom="offcanvas">NU</a></span>

      return {
        hasImage: hasImage,
        avatar: avatar,
        bg: bg
      };
    }
  }
};
</script>
<style>
.starter-page {
  min-height: calc(100vh - 380px);
}
</style>
